/* VINOD — Back in Stock Alert
   Captures Name / Email / Mobile on sold-out products and writes the shopper into
   Shopify Customers with product-specific tags.

   Submits to our own endpoint (the Cloudflare Worker), which uses the Admin API so
   tags are appended to EXISTING customers too. The old theme-native route
   (POST /contact, form_type=customer) only tagged brand-new customers and silently
   ignored anyone already registered.

   DIAGNOSTICS: add ?bisdebug=1 to the product URL and the red error line shows the
   exact reason the save failed, instead of the shopper-friendly wording.

   Tags written:
     stock-alert                     master waitlist
     stock-alert:<SKU or variantId>  one per variant
     stock-alert-date:YYYY-MM-DD     for ageing out stale requests
     sa-mob-<10 digits>              mobile mirrored into a tag
*/
(function () {
  'use strict';

  var LABEL = 'Alert Me When Back in Stock';
  var STORE_KEY = 'vinod:bis:signups';
  var SOLD_OUT_RE = /^\s*(sold\s*out|out of stock|unavailable)\s*$/i;
  /* Our endpoint. window.VINOD_BIS_ENDPOINT (set in the theme head) overrides this,
     so the address can be changed without touching this file — but the built-in
     default means the form still works if that line is ever missing. */
  var DEFAULT_ENDPOINT = 'https://vinod-stock-alert.web-a2a.workers.dev';
  var DEBUG = /[?&]bisdebug=1/.test(window.location.search);
  var modal = null;
  var ctx = {};
  var data = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function signedUp() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }

  function remember(variantId, email) {
    var all = signedUp();
    all[variantId] = { email: email, at: Date.now() };
    try { localStorage.setItem(STORE_KEY, JSON.stringify(all)); } catch (e) {}
  }

  /* ---------- modal ---------- */

  function build() {
    var el = document.createElement('div');
    el.className = 'vbis-scrim';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Back in stock alert');
    el.innerHTML = [
      '<div class="vbis-modal">',
      '  <div class="vbis-body" data-vbis-form-view>',
      '    <div class="vbis-head">',
      '      <div>',
      '        <p class="vbis-eyebrow">Back in stock alert</p>',
      '        <p class="vbis-title">Get an alert the moment it\u2019s back</p>',
      '        <p class="vbis-sub">We\u2019ll email you first. No spam, unsubscribe anytime.</p>',
      '      </div>',
      '      <button type="button" class="vbis-close" data-vbis-close aria-label="Close">\u2715</button>',
      '    </div>',
      '    <div class="vbis-product">',
      '      <span class="vbis-product__img" data-vbis-img></span>',
      '      <div>',
      '        <div class="vbis-product__title" data-vbis-name></div>',
      '        <div class="vbis-product__price" data-vbis-price></div>',
      '      </div>',
      '    </div>',
      '    <form class="vbis-fields" novalidate data-vbis-form>',
      '      <div class="vbis-field" data-field="name">',
      '        <label for="vbis-name">Full name</label>',
      '        <input id="vbis-name" name="name" type="text" autocomplete="name" placeholder="Anita Desai">',
      '        <span class="vbis-error" data-error></span>',
      '      </div>',
      '      <div class="vbis-field" data-field="email">',
      '        <label for="vbis-email">Email address</label>',
      '        <input id="vbis-email" name="email" type="email" inputmode="email" autocomplete="email" placeholder="anita@email.com">',
      '        <span class="vbis-error" data-error></span>',
      '      </div>',
      '      <div class="vbis-field" data-field="phone">',
      '        <label for="vbis-phone">Mobile number (+91) <span class="vbis-optional">optional</span></label>',
      '        <input id="vbis-phone" name="phone" type="tel" inputmode="numeric" maxlength="11" autocomplete="tel" placeholder="98200 00000">',
      '        <span class="vbis-error" data-error></span>',
      '      </div>',
      '      <label class="vbis-consent">',
      '        <input type="checkbox" name="consent" checked>',
      '        <span>Yes, send me the restock alert and VINOD offers by email and WhatsApp.</span>',
      '      </label>',
      '      <span class="vbis-error" data-form-error></span>',
      '      <button type="submit" class="vbis-submit">' + LABEL + '</button>',
      '      <button type="button" class="vbis-cancel" data-vbis-close>Cancel</button>',
      '    </form>',
      '  </div>',
      '  <div class="vbis-done vbis-hidden" data-vbis-done-view>',
      '    <div class="vbis-done__tick">\u2713</div>',
      '    <p class="vbis-done__title">You\u2019re on the list</p>',
      '    <p class="vbis-done__copy" data-vbis-done-copy></p>',
      '    <div class="vbis-done__actions">',
      '      <button type="button" class="vbis-btn vbis-btn--ghost" data-vbis-similar>Browse similar products</button>',
      '      <button type="button" class="vbis-btn vbis-btn--solid" data-vbis-close>Done</button>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');

    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('[data-vbis-close]')) close();
      if (e.target.closest('[data-vbis-similar]')) {
        var url = el.getAttribute('data-similar-url');
        if (url) window.location.href = url; else close();
      }
    });
    el.querySelector('[data-vbis-form]').addEventListener('submit', submit);
    document.body.appendChild(el);
    return el;
  }

  function fieldError(name, msg) {
    var wrap = modal.querySelector('[data-field="' + name + '"]');
    if (!wrap) return;
    wrap.classList.toggle('has-error', !!msg);
    wrap.querySelector('[data-error]').textContent = msg || '';
  }

  function open(btn) {
    if (!modal) modal = build();
    var d = btn.dataset;
    ctx = {
      productId: d.vbisProductId,
      title: d.vbisProductTitle,
      url: d.vbisProductUrl,
      variantId: d.vbisVariantId,
      variantTitle: d.vbisVariantTitle,
      sku: d.vbisSku,
      price: d.vbisPrice,
      compare: d.vbisCompare,
      image: d.vbisImage
    };

    var name = ctx.title + (ctx.variantTitle && ctx.variantTitle !== 'Default Title' ? ' \u2014 ' + ctx.variantTitle : '');
    modal.querySelector('[data-vbis-name]').textContent = name;
    modal.querySelector('[data-vbis-price]').innerHTML =
      '<b>' + esc(ctx.price) + '</b>' + (ctx.compare ? '<s>' + esc(ctx.compare) + '</s>' : '');
    modal.querySelector('[data-vbis-img]').style.backgroundImage = ctx.image ? 'url("' + ctx.image + '")' : 'none';
    modal.setAttribute('data-similar-url', ctx.url || '');

    var f = modal.querySelector('[data-vbis-form]');
    var known = signedUp()[ctx.variantId];
    var c = window.__vinodCustomer;
    if (c) {
      f.name.value = f.name.value || c.name || '';
      f.email.value = f.email.value || c.email || '';
      f.phone.value = f.phone.value || (c.phone || '').replace(/^\+91/, '');
    }
    if (known && known.email) f.email.value = known.email;

    ['name', 'email', 'phone'].forEach(function (k) { fieldError(k, ''); });
    modal.querySelector('[data-form-error]').textContent = '';
    modal.querySelector('[data-vbis-form-view]').classList.remove('vbis-hidden');
    modal.querySelector('[data-vbis-done-view]').classList.add('vbis-hidden');
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { f.name.focus(); }, 60);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function validate(f) {
    var ok = true;
    var digits = f.phone.value.replace(/\D/g, '');
    if (!f.name.value.trim()) { fieldError('name', 'Please enter your name.'); ok = false; } else fieldError('name', '');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.value.trim())) { fieldError('email', 'Enter a valid email address.'); ok = false; } else fieldError('email', '');
    // Mobile is optional — validated only when the shopper typed something.
    if (digits.length && digits.length !== 10) { fieldError('phone', 'Enter a 10-digit mobile number, or leave it blank.'); ok = false; } else fieldError('phone', '');
    var formError = modal.querySelector('[data-form-error]');
    if (ok && !f.consent.checked) {
      formError.textContent = 'Tick the consent box so we can email you.';
      ok = false;
    } else {
      formError.textContent = '';
    }
    return ok;
  }

  function submit(e) {
    e.preventDefault();
    var f = e.currentTarget;
    if (!validate(f)) return;

    var endpoint = window.VINOD_BIS_ENDPOINT || DEFAULT_ENDPOINT;

    var btn = f.querySelector('.vbis-submit');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding you to the list\u2026';

    var digits = f.phone.value.replace(/\D/g, '');
    var email = f.email.value.trim();

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: f.name.value.trim(),
        email: email,
        phone: digits,
        consent: !!f.consent.checked,
        product_id: ctx.productId,
        product_title: ctx.title,
        variant_id: ctx.variantId,
        variant_title: ctx.variantTitle,
        sku: ctx.sku
      })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (out) {
          // Only report success when the customer record was actually written.
          if (!res.ok || !out.ok) throw new Error(out.error || ('http_' + res.status));
          return out;
        });
      })
      .then(function () {
        remember(ctx.variantId, email);
        modal.querySelector('[data-vbis-done-copy]').innerHTML =
          'We\u2019ll alert <strong>' + esc(email) + '</strong> as soon as ' +
          esc(ctx.title) + ' is back in stock.';
        modal.querySelector('[data-vbis-form-view]').classList.add('vbis-hidden');
        modal.querySelector('[data-vbis-done-view]').classList.remove('vbis-hidden');
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'back_in_stock_signup',
            product_id: ctx.productId,
            variant_id: ctx.variantId,
            sku: ctx.sku
          });
        }
      })
      .catch(function (err) {
        var reason = String(err && err.message ? err.message : err);
        modal.querySelector('[data-form-error]').textContent = DEBUG
          ? 'DEBUG \u2014 ' + reason
          : 'We could not save your request. Please try again in a moment.';
        if (window.console) console.error('[VINOD back-in-stock]', reason);
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  /* ---------- product page injection ----------
     The PDP's buy box is theme-owned, so instead of editing it the module finds the
     disabled Sold out / Out of stock button and puts the alert button in its place.
     Works across variant changes and re-renders. */

  function currentVariant() {
    if (!data || !data.variants || !data.variants.length) return null;
    var id = new URLSearchParams(window.location.search).get('variant');
    var match = id && data.variants.filter(function (v) { return String(v.id) === String(id); })[0];
    return match || data.variants.filter(function (v) { return !v.available; })[0] || data.variants[0];
  }

  function makeTrigger(v) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vbis-trigger vbis-trigger--primary vbis-trigger--md';
    b.setAttribute('data-vbis-open', '');
    b.setAttribute('data-vbis-injected', '');
    b.dataset.vbisProductId = data.product_id;
    b.dataset.vbisProductTitle = data.title;
    b.dataset.vbisProductUrl = data.url;
    b.dataset.vbisVariantId = v.id;
    b.dataset.vbisVariantTitle = v.title;
    b.dataset.vbisSku = v.sku || v.id;
    b.dataset.vbisPrice = v.price;
    b.dataset.vbisCompare = v.compare || '';
    b.dataset.vbisImage = data.image || '';
    b.innerHTML = '<span class="vbis-trigger__label">' + LABEL + '</span><span class="vbis-trigger__chev" aria-hidden="true">\u203a</span>';
    return b;
  }

  function inject() {
    if (!data) return;
    var v = currentVariant();
    if (!v || v.available) {
      document.querySelectorAll('[data-vbis-injected], .vbis-waiting--injected').forEach(function (n) { n.remove(); });
      document.querySelectorAll('[data-vbis-hidden]').forEach(function (n) {
        n.style.display = '';
        n.removeAttribute('data-vbis-hidden');
      });
      return;
    }

    var scope = document.querySelector('.main-content') || document.body;
    var buttons = Array.prototype.slice.call(scope.querySelectorAll('button[disabled], .btn[disabled], [aria-disabled="true"]'));
    buttons.forEach(function (btn) {
      if (btn.closest('[data-vbis-scrim]') || btn.hasAttribute('data-vbis-hidden')) return;
      if (!SOLD_OUT_RE.test(btn.textContent)) return;
      var host = btn.closest('.shopify-payment-button') ? null : btn;
      if (!host || !host.parentNode) return;

      var trigger = makeTrigger(v);
      var wrap = document.createElement('div');
      wrap.setAttribute('data-vbis-injected', '');
      wrap.style.width = '100%';
      wrap.appendChild(trigger);
      if (data.waiting) {
        var p = document.createElement('p');
        p.className = 'vbis-waiting';
        p.textContent = data.waiting + ' shoppers waiting for this item';
        wrap.appendChild(p);
      }
      host.parentNode.insertBefore(wrap, host.nextSibling);
      host.style.display = 'none';
      host.setAttribute('data-vbis-hidden', '');
    });
  }

  var t;
  function scheduleInject() {
    clearTimeout(t);
    t = setTimeout(inject, 120);
  }

  function start() {
    var el = document.getElementById('vinod-bis-data');
    if (el) {
      try { data = JSON.parse(el.textContent); } catch (e) { data = null; }
    }
    inject();
    if (data) {
      var scope = document.querySelector('.main-content');
      if (scope && window.MutationObserver) {
        new MutationObserver(scheduleInject).observe(scope, { childList: true, subtree: true });
      }
      window.addEventListener('popstate', scheduleInject);
      document.addEventListener('variant:change', scheduleInject);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vbis-open]');
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
